import React, { Component } from 'react'
import OutsideClick from 'components/UI/OutsideClick'
import { SearchIcon, CrossIcon } from 'components/icons'
import {
  SearchBox,
  SearchInput,
  SearchClear,
  SearchBar,
  SearchIconWrapper,
  SearchClearWrapper
} from './styles'

interface SearchProps {
  onSearch?: (value: string) => void
  onHandleClear?: () => void
}

interface SearchState {
  isOpen: boolean
  search: string
}

class Search extends Component<SearchProps, SearchState> {
  state = { isOpen: false, search: '' }

  toggleSearch = () => {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }))
  }

  handleClear = () => {
    const { onHandleClear } = this.props
    if (onHandleClear) {
      onHandleClear()
    }
    this.setState({ search: '' })
  }

  handleChange = (name: string, value: string) => {
    const { onSearch } = this.props
    this.setState({ search: value })
    if (onSearch) {
      onSearch(value)
    }
  }

  onCloseSearch = () => {
    const { search } = this.state

    if (!search) {
      this.setState({ isOpen: false })
    }
  }

  render() {
    const { isOpen, search } = this.state

    return (
      <OutsideClick onOutsideClick={this.onCloseSearch}>
        <SearchBox isOpen={isOpen}>
          <SearchIconWrapper onClick={this.toggleSearch}>
            <SearchIcon />
          </SearchIconWrapper>
          {isOpen && (
            <SearchBar>
              <SearchInput
                placeholder="Search"
                name="search"
                handleChange={this.handleChange}
                value={search}
              />
              <SearchClearWrapper>
                <SearchClear isOpen={isOpen} onClick={this.handleClear}>
                  <CrossIcon />
                </SearchClear>
              </SearchClearWrapper>
            </SearchBar>
          )}
        </SearchBox>
      </OutsideClick>
    )
  }
}

export default Search

export { Search }
